/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./aiSpeech.vue?vue&type=template&id=0e4f1b4d&scoped=true&"
import script from "./aiSpeech.vue?vue&type=script&lang=js&"
export * from "./aiSpeech.vue?vue&type=script&lang=js&"
import style0 from "./aiSpeech.vue?vue&type=style&index=0&id=0e4f1b4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4f1b4d",
  null
  
)

export default component.exports